/* ========== Start Blog Listing Page JS ========== */
document.addEventListener("DOMContentLoaded", function() {
    var parentclass = $('.infinite-scroll-pagination');
    document.getElementById("view-all-posts").addEventListener("click", function() {
        var endlessScroll = new Ajaxinate({
          container: '.blog-list-view',
          pagination: '.infinite-scroll'
        });
        $('.Polaris-ProgressBar__Progress').val(100);
        var totallastcount = parseInt($('.blog-count .collection-all-posts').text());
        $('.blog-count .blogs-per-page').text(totallastcount);
        parentclass.hide();
        $('#blogLoadMore').hide();
    });
});

$(document).ready(function(){
  var shopurl = $('.loadmore-posts-section .blog-count .shop-base-url').val();
  var handle = $('.loadmore-posts-section .blog-count .current-url-handle').val();
  var counter = 2
  var blogtotalcount = parseInt($('.loadmore-posts-section .blog-count .collection-all-posts').text());
  var cuurentpagecount = parseInt($('.loadmore-posts-section .blog-count .blogs-per-page').text());
  var pages = Math.ceil(blogtotalcount / cuurentpagecount);
  var postlength = $('.blog-list-view .article-main-tag').length;
  $('.loadmore-posts-section .blog-count .blogs-per-page').text(postlength);
  var percentageblogs = (postlength / blogtotalcount)*100;
  $('.loadmore-posts-section .Polaris-ProgressBar__Progress').val(percentageblogs);
  var maxCount = pages + 1;
  $('.loadmore-posts-section #blogLoadMore').click(function(e) {
      e.preventDefault();
      var getUrl = shopurl+"/blogs/"+handle+"?page="+counter;
      $.ajax({
           url: getUrl,
           type:'GET',
           success: function(data){
              $('.blog-list-view').append($(data).find('.blog-list-view').html());
              var updatedpostlength = $('.blog-list-view .article-main-tag').length;
              var updatedpercentageblogs = (updatedpostlength / blogtotalcount)*100;
              console.log(updatedpercentageblogs);

              // re-run galleryView function when "load more" is complete
              if (isGalleryPage()) {
                //galleryView();
                galleryMagnifierPop();
              };
              
              $('.loadmore-posts-section .Polaris-ProgressBar__Progress').val(updatedpercentageblogs);
              $('.loadmore-posts-section .blog-count .blogs-per-page').text(updatedpostlength);
              counter++;
              if(counter == maxCount ) {
                  $('.loadmore-posts-section #blogLoadMore').empty();
                  $('.loadmore-posts-section .infinite-scroll-pagination').hide();
              }

           }
      });
  });

// Tags dropdown.
$('.header-column-dropdown').on('click', function(e) {
  const $dropdownWrapper = $(this).find('.dropdown-list-wrapper');
  if ($(this).hasClass('open')) {
    $dropdownWrapper.css('max-height', '0');
    $(this).removeClass('open');
  } else {
    $dropdownWrapper.css('max-height', '330px');
    $(this).addClass('open');
  }
});

  
})


/* ========== End Blog Listing Page JS ========== */


// ========== Start - Grace Brides Gallery Page JS ==========
function isGalleryPage() {
  if (window.location.href.includes('grace-brides-gallery')) {
    return true;
  } else {
    return false;
  };
};

function getImages() {
  const images = document.querySelectorAll('.article__list-image');

  return images;
};

function galleryView() {
  const images = getImages();

  images.forEach((image) => {
    image.addEventListener('click', (e) => {
      e.preventDefault();

      // create modal
      const blogGalleryModal = document.createElement('div');
      blogGalleryModal.classList.add('blog-gallery-modal');

      // create and insert image duplicate to modal
      const imageDuplicate = new Image();
      imageDuplicate.src = image.getAttribute('src');
      imageDuplicate.classList.add('image-duplicate');
      blogGalleryModal.insertAdjacentElement('afterbegin', imageDuplicate);

      // create and insert close button
      const closeDiv = document.createElement('div');
      closeDiv.classList.add('modal-close-button');
      closeDiv.insertAdjacentHTML('afterbegin', '<svg class="modal-close-button-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 5L5 19" stroke="#ffffff" stroke-width="1.25"/><path d="M5 5L19 19" stroke="#ffffff" stroke-width="1.25"/></svg>');
      blogGalleryModal.insertAdjacentElement('afterbegin', closeDiv);

      // insert modal to body
      document.body.insertAdjacentElement('afterbegin', blogGalleryModal);

      // modal style
      blogGalleryModal.style.cssText = `
        position: fixed;
        z-index: 999;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
      `;
      
      // image style
      if (window.innerWidth > 768) {
        imageDuplicate.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 50%;
          height: auto;
        `;
      } else {
        imageDuplicate.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 90%;
          height: auto;
        `;
      };

      // close button style
      closeDiv.style.cssText = `
        position: absolute;
        top: 2rem;
        right: 2rem;
        cursor: pointer;
      `;

      // body style
      document.body.style.cssText = `
        overflow: hidden;
      `;

      document.querySelector('#PageContainer').style.cssText = `
        overflow: hidden;
      `;

      // close modal - close button
      closeDiv.addEventListener('click', () => {
        blogGalleryModal.remove();

        document.body.style.cssText = `
          overflow: initial;
        `;

        document.querySelector('#PageContainer').style.cssText = `
          overflow: initial;
        `;
      });

      // close modal - click outside of image
      blogGalleryModal.addEventListener('click', (e) => {
        if (e.target != imageDuplicate) {
          blogGalleryModal.remove();

          document.body.style.cssText = `
            overflow: initial;
          `;

          document.querySelector('#PageContainer').style.cssText = `
            overflow: initial;
          `;
        };
      });
    });
  });
};

function galleryMagnifierPop() {
  $('#grace-brides-gallery .article-main-tag').magnificPopup({
    delegate: 'a',
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    closeOnBgClick: false,
    image: {
      verticalFit: true
    },
    gallery: {
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)',
      enabled: true,
      navigateByImgClick: false
    },
    zoom: {
      enabled: true,
      duration: 300,
      opener: function(element) {
        return element.find('img');
      }
    }
  });
}

// image zoom function for gallery page
function zoom() {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('article__list-image')) {
      const image = document.querySelector('.mfp-img');
      const arrows = document.querySelectorAll('.mfp-arrow');

      if (image) {
        image.addEventListener('click', (e) => {
          e.target.classList.toggle('mfp-img--zoomed');
        });
      };

      if (arrows.length) {
        arrows.forEach((arrow) => {
          arrow.addEventListener('click', (e) => {
            const image = document.querySelector('.mfp-img');
            const arrows = document.querySelectorAll('.mfp-arrows');

            if (image) {
              image.addEventListener('click', (e) => {
                e.target.classList.toggle('mfp-img--zoomed');
              });
            };
          });
        });
      };
    };
  });
};


if (isGalleryPage()) {
  //galleryView();
  // galleryMagnifierPop();
  // zoom();
};

// ========== End - Grace Brides Gallery Page JS ==========